import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExposedCreateAzureEnvironmentReservationReq } from 'app/interfaces/requests/Exposed/exposedCreateAzureEnvironmentReservationReq';
import { ExposedListAzureEnvironmentReservationRes } from 'app/interfaces/responses/Exposed/exposedListAzureEnvironmentReservationRes';
import { AzureEnvironmentService } from 'app/services/api/azure/azure-environment.service';
import { AZURE_RESERVABLE_ENVIRONMENTS } from 'common/constants/azure-environments.constants';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-azure-environment-reservations',
    templateUrl: './azure-environment-reservations.component.html',
    styleUrls: ['./azure-environment-reservations.component.scss'],
})
export class AzureEnvironmentReservationsComponent implements OnInit, OnDestroy {
    environments = AZURE_RESERVABLE_ENVIRONMENTS;
    selectedEnvironment: string = AZURE_RESERVABLE_ENVIRONMENTS.DEV;

    stateList = true;
    stateAdd = false;

    reservations: ExposedListAzureEnvironmentReservationRes[] = [];

    private subs = new Subscription();

    constructor(private azureEnvironmentService: AzureEnvironmentService) {}

    ngOnInit(): void {
        this.loadReservations();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    onEnvironmentChange(): void {
        this.cancelAdd();
        this.loadReservations();
    }

    showAdd(): void {
        this.stateList = false;
        this.stateAdd = true;
    }

    cancelAdd(): void {
        this.stateList = true;
        this.stateAdd = false;
    }

    onSave(req: ExposedCreateAzureEnvironmentReservationReq): void {
        this.subs.add(
            this.azureEnvironmentService.createAzureEnvironmentReservation(req).subscribe(() => {
                this.cancelAdd();
                this.loadReservations();
            })
        );
    }

    onDelete(reservationId: number): void {
        this.subs.add(
            this.azureEnvironmentService.deleteAzureEnvironmentReservation(reservationId).subscribe(() => {
                this.loadReservations();
            })
        );
    }

    private loadReservations(): void {
        this.subs.add(
            this.azureEnvironmentService.listAzureEnvironmentReservations(this.selectedEnvironment).subscribe((res) => {
                this.reservations = res ?? [];
            })
        );
    }
}
